import { renderToStaticMarkup } from "react-dom/server";
import * as XLSX from "xlsx";
import React from "react";
import {useTheme} from "../../../Commons/Scripts/Hooks";
import {SelectButton } from 'primereact'
import {
    useBuscarAnticiposGraficoDashboard,
    useBuscarFacturasDescuentoGraficoDashboard,
    useBuscarFacturasGraficoDashboard,
    useBuscarNotasCreditoDevolucionGraficoDashboard,
    useBuscarNotasCreditoGraficoDashboard,
    useBuscarNotasDebitoGraficoDashboard,
    useBuscarRecibosGraficoDashboard,
    useBuscarTasasGraficoDashboard
} from "../Services/cxc-service";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";

export const GraficosCxc = () => {
    const {theme} = useTheme();
    const [cargando, setCargando] = React.useState(true);
    const [where, setWhere] = React.useState({where :{periodo:'mensual'}});
    const moneda = window.monedaPredeterminada;
    
    const {data: facturasGrafico } = useBuscarFacturasGraficoDashboard(where);
    const {data: facturaDescuentoGrafico } = useBuscarFacturasDescuentoGraficoDashboard(where);
    const {data: tasasGrafico } = useBuscarTasasGraficoDashboard(where);
    const {data: notasCreditoGrafico } = useBuscarNotasCreditoGraficoDashboard(where);
    const {data: notasDebitoGrafico } = useBuscarNotasDebitoGraficoDashboard(where);
    const {data: anticiposGrafico } = useBuscarAnticiposGraficoDashboard(where);
    const {data: recibosGrafico} = useBuscarRecibosGraficoDashboard(where);
    const {data: notasCreditoDevolcion} = useBuscarNotasCreditoDevolucionGraficoDashboard(where);
    const [value, setValue] = React.useState(3);
    const periodos = [
        { name: 'Dario', value: 1 },
        { name: 'Semanal', value: 2 },
        { name: 'Mensual', value: 3 },
        { name: 'Trimestral', value: 4 },
        { name: 'Anual', value: 5 }
    ];
    function m(n, d) {
        //Convertir numero => 3,000,000 a 3M
        const x = Math.floor(Math.log10(Math.abs(n)));
        const suffix = ['','k','M','MM','T','P','E'];
        const magnitude = Math.floor(x / 3);
        const scaled = n / Math.pow(10, magnitude * 3);
        const rounded = Math.round(scaled * Math.pow(10, d)) / Math.pow(10, d);

        return rounded + ' ' + suffix[magnitude];
    }
    function handleChange(value) {
        localStorage.setItem('periodoGrafico', JSON.stringify(value))
        setValue(value);
        switch(value){
            case 1:
                setWhere({where: {periodo:'diario'}});
                break;
            case 2:
                setWhere({where: {periodo:'semanal'}});
                break;
            case 3:
                setWhere({where: {periodo:'mensual'}});
                break;
            case 4:
                setWhere({where: {periodo:'trimestral'}});
                break;
            case 5:
                setWhere({where: {periodo:'anual'}})
                break;
        }
        setCargando(true);
    }
    function crearDivGrafico(data){
        let dom = document.getElementById('chart_' + data.Titulo);
        if (dom) {
            var chartTemp = echarts.getInstanceByDom(document.getElementById('chart_' + data.Titulo));
            if (chartTemp) {
                chartTemp.dispose();
            }
        } else {
            let chart = document.createElement('div');
            chart.setAttribute('id', 'chart_' + data.Titulo)
            chart.setAttribute('class', 'chart');
            document.getElementById('chart_holder').appendChild(chart);
        }
    }
    function crearGraficos(data) {
        crearDivGrafico(data);
        const svgString = renderToStaticMarkup(<SvgComponent
            iconName="export"
            fill={theme.color1}
        />);
        const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
        let dom = document.getElementById('chart_' + data.Titulo);
        if (dom) {
            var chartTemp = echarts.getInstanceByDom(document.getElementById('chart_' + data.Titulo));
            if (chartTemp) {
                chartTemp.dispose();
            }
        } else {
            let chart = document.createElement('div');
            chart.setAttribute('id', 'chart_' + data.Titulo)
            chart.setAttribute('class', 'chart');
            document.getElementById('chart_holder').appendChild(chart);
        }
        var chartDom = document.getElementById('chart_' + data.Titulo);
        var myChart = echarts.init(chartDom, null, {
            renderer: 'canvas',
            height: '300',
        });
        var option;
        var color = ['#3fb1e3', '#91cc75', '#fac858', '#ee6666'];
        var labelOptions = {
            show: true,
            rotate: 90,
            align: 'left',
            position: 'insideBottom',
            verticalAlign: 'middle'
        }
        option = {
            color: color,
            title: {
                text: data.Titulo,
                left: 'center',
                textStyle: {
                    fontStyle: 'normal',
                    fontWeight: 'bolder',
                    fontFamily: 'sans-serif'
                }
            },
            legend: {
                orient: 'horizontal',
                left: 'center',
                top: 'bottom',
                data: ['Promedio', 'Total']
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
            },
            toolbox: {
                show: true,
                feature: {
                    myTool1: {
                        show: true,
                        title: 'exportar',
                        icon: `image://${svgDataUrl}`,
                        onclick: function (){
                            const option = myChart.getOption();
                            const source = option.dataset[0].source;
                            const dimensions = option.dataset[0].dimensions;

                            const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                            const ws = XLSX.utils.aoa_to_sheet(rows);
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                            XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                        }
                    }
                }
            },
            dataset: {
                dimensions: ['periodo', 'Cantidad', 'Promedio', 'Total'],
                source: data.Resultados.map((d) => {
                    return {
                        periodo: d.FechaDesc,
                        Cantidad: d.Cantidad,
                        Promedio: d.Promedio,
                        Total: d.Monto,
                    }
                })
            },
            xAxis: { type: 'category', },
            yAxis: {
                type: 'value',
                axisLabel: {
                    fontSize: 9,
                    formatter: function (params) {
                        if(params >= 1000) return `${moneda} ${m(params,1)}`
                        else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`
                    }
                },
            },
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series:
                [
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        barGap: 0,
                        barWidth: 1
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            ...labelOptions,
                            formatter: function (params) {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Total)
                            },
                        },
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        }
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            ...labelOptions,
                            formatter: function (params) {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Promedio)
                            },
                        },
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        }
                    },
                ]
        };
        myChart.on('click', function (params) {
            let fechaInicio;
            let fechaFin = (data.Resultados[params.dataIndex]).FechaDesc;
            if (params.dataIndex === 0) {
                let temp = new Date();
                if (v_periodo === "semanal") {
                    temp.setDate(temp.getDate() - 42);
                    let dayMonth = temp.toLocaleDateString().split('/')
                    fechaInicio = dayMonth[1]+"/"+dayMonth[0];
                } else if (v_periodo === "trimestral") {
                    temp.setFullYear(temp.getFullYear(), 1, 1);
                    temp.setMonth(temp.getMonth() - 12);
                    fechaInicio = temp.getMonth() + "/" + temp.getFullYear();
                } else {
                    fechaInicio = (data.Resultados[params.dataIndex]).FechaDesc;
                }
            } else {
                const prevFecha = data.Resultados[params.dataIndex - 1].FechaDesc;

                if (v_periodo === "semanal") {
                    fechaInicio = prevFecha;
                } else if (v_periodo === "trimestral") {
                    let [prevMonth, prevYear] = prevFecha.split('/');
                    let nextMonth = parseInt(prevMonth) + 1;
                    if (nextMonth >= 13) {
                        prevMonth = 1;
                        prevYear = parseInt(prevYear) + 1;
                    }
                    fechaInicio = `${prevMonth}/${prevYear}`;
                } else {
                    fechaInicio = data.Resultados[params.dataIndex].FechaDesc;
                }
            }
            window.location.href = data.Url+ "inicio=" + fechaInicio + "&fin=" + fechaFin+ "&periodo=" + v_periodo;
        })
        myChart.setOption(option);
    }
    function crearGraficosTasa(data) {
        crearDivGrafico(data);
        const svgString = renderToStaticMarkup(<SvgComponent
            iconName="export"
            fill={theme.color1}
        />);
        const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
        let dom = document.getElementById('chart_' + data.Titulo);
        if (dom) {
            var chartTemp = echarts.getInstanceByDom(document.getElementById('chart_' + data.Titulo));
            if (chartTemp) {
                chartTemp.dispose();
            }
        } else {
            let chart = document.createElement('div');
            chart.setAttribute('id', 'chart_' + data.Titulo)
            chart.setAttribute('class', 'chart');
            document.getElementById('chart_holder').appendChild(chart);
        }
        var chartDom = document.getElementById('chart_' + data.Titulo);

        var myChart = echarts.init(chartDom, null, {
            renderer: 'canvas',
            height: '300',
            width: '630'
        });
        var option;
        var color = ['#3fb1e3', '#91cc75', '#fac858', '#ee6666'];
        var labelOptions = {
            show: true,
            rotate: 90,
            align: 'left',
            position: 'insideBottom',
            verticalAlign: 'middle'
        }

        option = {
            color: color,
            title: {
                text: data.Titulo,
                left: 'center',
                textStyle: {
                    fontStyle: 'normal',
                    fontWeight: 'bolder',
                    fontFamily: 'sans-serif'
                }
            },
            legend: {
                orient: 'horizontal',
                left: 'center',
                top: 'bottom',
                data: ['Promedio', 'Total']
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
            },
            toolbox: {
                show: true,
                feature: {
                    myTool1: {
                        show: true,
                        title: 'exportar',
                        icon: `image://${svgDataUrl}`,
                        onclick: function (){
                            const option = myChart.getOption();
                            const source = option.dataset[0].source;
                            const dimensions = option.dataset[0].dimensions;

                            const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                            const ws = XLSX.utils.aoa_to_sheet(rows);
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                            XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                        }
                    }
                }
            },
            dataset: {
                dimensions: ['periodo', 'Cantidad', 'Promedio', 'Total', 'Tasa'],
                source: data.Resultados.map((d) => {
                    return {
                        periodo: d.FechaDesc,
                        Cantidad: d.Cantidad,
                        Total: d.Monto,
                        Promedio: d.Promedio,
                        Tasa: d.Tasa
                    }
                })
            },
            xAxis: { type: 'category' },
            yAxis: {
                type: 'value',
                axisLabel: {
                    fontSize: 9,
                    formatter: function (params) {
                        if(params >= 1000) return `${moneda} ${m(params,1)}`
                        else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`
                    }
                },
            },
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series:
                [
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false
                        },
                        barGap: 0,
                        barWidth: 1
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            ...labelOptions,
                            formatter: function (params) {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Total)
                            },
                        },
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        }
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            ...labelOptions,
                            formatter: function (params) {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Promedio)
                            },
                        },
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        }
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false
                        },
                        tooltip: {
                            valueFormatter: value => value.toFixed(2) + ' %'
                        },
                        barWidth: 1
                    }
                ]
        };
        myChart.on('click', function (params) {
            let fechaInicio;
            let fechaFin = (data.Resultados[params.dataIndex]).FechaDesc;
            if (params.dataIndex === 0) {
                let temp = new Date();
                if (v_periodo === "semanal") {
                    temp.setDate(temp.getDate() - 42);
                    let dayMonth = temp.toLocaleDateString().split('/')
                    fechaInicio = dayMonth[1]+"/"+dayMonth[0];
                } else if (v_periodo === "trimestral") {
                    temp.setFullYear(temp.getFullYear(), 1, 1);
                    temp.setMonth(temp.getMonth() - 12);
                    fechaInicio = temp.getMonth() + "/" + temp.getFullYear();
                } else {
                    fechaInicio = (data.Resultados[params.dataIndex]).FechaDesc;
                }
            } else {
                const prevFecha = data.Resultados[params.dataIndex - 1].FechaDesc;

                if (v_periodo === "semanal") {
                    fechaInicio = prevFecha;
                } else if (v_periodo === "trimestral") {
                    let [prevMonth, prevYear] = prevFecha.split('/');
                    let nextMonth = parseInt(prevMonth) + 1;
                    if (nextMonth >= 13) {
                        prevMonth = 1;
                        prevYear = parseInt(prevYear) + 1;
                    }
                    fechaInicio = `${prevMonth}/${prevYear}`;
                } else {
                    fechaInicio = data.Resultados[params.dataIndex].FechaDesc;
                }
            }
            window.location.href = data.Url+ "inicio=" + fechaInicio + "&fin=" + fechaFin + "&periodo=" + v_periodo;
        })

        myChart.setOption(option);
    }
    function crearGraficoDeTasas(data) {
        crearDivGrafico(data);
        const svgString = renderToStaticMarkup(<SvgComponent
            iconName="export"
            fill={theme.color1}
        />);
        const svgDataUrl = `data:image/svg+xml;base64,${btoa(svgString)}`;
        let dom = document.getElementById('chart_' + data.Titulo);
        if (dom) {
            var chartTemp = echarts.getInstanceByDom(document.getElementById('chart_' + data.Titulo));
            if (chartTemp) {
                chartTemp.dispose();
            }
        } else {
            let chart = document.createElement('div');
            chart.setAttribute('id', 'chart_' + data.Titulo)
            chart.setAttribute('class', 'chart');
            document.getElementById('chart_holder').appendChild(chart);
        }
        var chartDom = document.getElementById('chart_' + data.Titulo);

        var myChart = echarts.init(chartDom, null, {
            renderer: 'canvas',
            height: '300',
            width: '630'
        });
        var option;

        option = {
            title: {
                text: data.Titulo,
                left: 'center',
                textStyle: {
                    fontStyle: 'normal',
                    fontWeight: 'bolder',
                    fontFamily: 'sans-serif'
                }
            },
            tooltip: {
                trigger: 'axis',
                valueFormatter: value => value.toFixed(2) + ' %'
            },
            legend: {
                orient: 'horizontal',
                left: 'center',
                top: 'bottom'
            },
            toolbox: {
                show: true,
                feature: {
                    myTool1: {
                        show: true,
                        title: 'exportar',
                        icon: `image://${svgDataUrl}`,
                        onclick: function (){
                            const option = myChart.getOption();
                            const source = option.dataset[0].source;
                            const dimensions = option.dataset[0].dimensions;

                            const rows = [dimensions, ...source.map(obj => dimensions.map(dim => obj[dim]))];

                            const ws = XLSX.utils.aoa_to_sheet(rows);
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

                            XLSX.writeFile(wb, `${data.Titulo || "chart-data"}.xlsx`);
                        }
                    }
                }
            },
            dataset: {
                dimensions: ['periodo', 'Cantidad', 'Total', 'Promedio'],
                source: data.Resultados.map((d) => {
                    return {
                        periodo: d.FechaDesc,
                        Cantidad: d.Cantidad,
                        Total: d.Monto,
                        Promedio: d.Promedio,
                    }
                })
            },
            xAxis: { type: 'category', boundaryGap: false, },
            yAxis: {
                type: 'value',
                axisLabel: { formatter: '{value} %' }
            },
            series: [
                {
                    name: 'Tasa de Morosidad',
                    type: 'line',
                },
                {
                    name: 'Tasa de Cobro',
                    type: 'line',
                },
                {
                    name: 'Tasa de Impagos',
                    type: 'line',
                }
            ]
        };
        myChart.setOption(option);
    }

    React.useEffect(() => {
        if(facturasGrafico) {
            crearGraficos(facturasGrafico);
        }
    },[facturasGrafico])
    React.useEffect(() => {
        if(facturaDescuentoGrafico) {
            crearGraficosTasa(facturaDescuentoGrafico);
        }
    }, [facturaDescuentoGrafico])
    React.useEffect(() => {
        if(tasasGrafico) {
            crearGraficoDeTasas(tasasGrafico);
        }
    },[tasasGrafico])
    React.useEffect(() => {
        if(notasCreditoGrafico) {
            crearGraficos(notasCreditoGrafico);
        }
    }, [notasCreditoGrafico])
    React.useEffect(() => {
        if(notasDebitoGrafico) {
            crearGraficos(notasDebitoGrafico);
        }
    }, [notasDebitoGrafico])
    React.useEffect(() => {
        if(anticiposGrafico) {
            crearGraficos(anticiposGrafico);
        }
    }, [anticiposGrafico])
    React.useEffect(() => {
        if(recibosGrafico) {
            crearGraficos(recibosGrafico);
        }
    }, [recibosGrafico])
    React.useEffect(() => {
        if(notasCreditoDevolcion) {
            crearGraficosTasa(notasCreditoDevolcion);
        }
    }, [notasCreditoDevolcion])
    
    return (
        <div>
            <SelectButton
                value={value}
                onChange={(e) => handleChange(e.value)}
                optionLabel='name'
                options= {periodos}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '10px',
                    padding: '12px',
                    flexFlow: 'columnWrap',
                    aligItems: 'center',}}
            />
            <div id="chart_holder" className="card_row">
            </div>
        </div>
    )
    
}